import alpha from "color-alpha";
const MuiFilledInput = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.common.white,
      "&.Mui-focused": {
        backgroundColor: theme.palette.common.white
      },
      "&:hover:not(.Mui-disabled)": {
        backgroundColor: theme.palette.grey[100]
      },
      "&.Mui-disabled": {
        backgroundColor: alpha(theme.palette.common.white || "", 0.04)
      },
      "&.Mui-error::before": {
        borderBottom: `1px solid ${theme.palette.error[800]}`
      },
      "&.Mui-error::after": {
        borderBottom: `2px solid ${theme.palette.error[800]}`
      }
    }),
    underline: ({ theme }) => ({
      "&::before, &:hover:not(.Mui-disabled)::before, &.Mui-disabled::before": {
        borderBottom: `1px solid ${theme.palette.grey[800]}`
      },
      "&.Mui-disabled::before": {
        borderBottom: `1px solid ${alpha(theme.palette.grey[800], 0.38)}`
      },
      "&::after": {
        borderBottom: `2px solid ${theme.palette.primary[800]}`
      }
    }),
    input: {
      paddingLeft: "16px",
      paddingRight: "16px",
      "&.Mui-disabled": {
        opacity: 0.38
      }
    }
  }
};
export {
  MuiFilledInput
};
